const UrlNameResource = '/resource/v1/resource'
const UrlNameResAccessToken = '/resource/v1/resAccessToken'
export default API => ({
  // 老接口 可能需要替换
  getPlayAuthToken ({ data, params }) {
    return API({ url: `${UrlNameResAccessToken}/getPlayAuthToken`, data, params })
  },
  // 老接口 可能需要替换  查看图片
  getImageOrDocUrl ({ data, params }) {
    return API({ url: `${UrlNameResource}/getImageOrDocUrl`, data, params })
  },
   // 新接口 文档，
   getDocumentAccessToken(id) {
        return API({ url: `${UrlNameResAccessToken}/getDocumentAccessToken?resId=${id}`})
    },
  // 最近学习
  getVideoPlayURL ({ data, params }) {
    return API({ url: `${UrlNameResource}/getVideoPlayURL`, data, params })
  },
  // 查视频完整url
  findById ({ data, params }) {
    return API({ url: `${UrlNameResource}/findById`, data, params })
  },
  getSourseDetail({data, params}) {
      return API({ url: `/resource/v1/resource/findById`, params, data });
  },
  // 获取上传视频的id
  getUploadVideoParam(url) {
    return API({ url: `/resource/v1/resource/createUploadVideo?${url}`, method:  'post' })
  },
  refreshUploadVideo(url) {
    return API({ url: `/resource/v1/resource/refreshUploadVideo?${url}` })
    // return axios.get('/resource/v1/resource/refreshUploadVideo', data);
  },
  downFile(resId){
    return API({ url: `/resource/v1/resource/downHomeworkFile?resId=${resId}`})
  },
  // 文档，图片url
  getImageOrDocUrls(id) {
    return API({ url: `/resource/v1/resAccessToken/getDocumentAccessToken?resId=${id}`})
  },
  // 查看完整视频 通过vid
  previewMedias(videoId) {
    return API({ url: `/resource/v1/resAccessToken/getPlayAuthToken?resId=${videoId}`})
  },
})